<div class="content-container">
  <mat-toolbar class="sticky-toolbar">
    <h2>
      <span class="opacity-75">
        <a routerLink="/home" id="account-breadcrumb-home">Home</a> /
      </span>
      {{ pageTitle }}
    </h2>
    <span class="spacer"></span>
    <button mat-mini-fab [matMenuTriggerFor]="accountActions" id="account-actions-button" matTooltip="More options">
      <mat-icon>menu</mat-icon>
    </button>
    <mat-menu #accountActions="matMenu">
      <button mat-menu-item id="account-refresh-button" (click)="refresh()">
        <mat-icon>refresh</mat-icon>
        Refresh
      </button>
    </mat-menu>
  </mat-toolbar>

  <div class="sub-content-container">
    <div class="container-fluid pd-20">
      <mat-card class="portal-page-card">
        <mat-card-content>
          <app-account-details-tab *ngIf="activetab === 1" #accountDetailsTab></app-account-details-tab>
          <app-add-contracts-tab *ngIf="activetab === 2" #addContractsTab></app-add-contracts-tab>
          <app-invite-users-tab *ngIf="activetab === 3" #inviteUsersTab></app-invite-users-tab>
          <app-reset-question-tab *ngIf="activetab === 4" #resetQuestionTab></app-reset-question-tab>
          <app-change-password-tab *ngIf="activetab === 5" #changePasswordTab></app-change-password-tab>
          <app-delete-user *ngIf="activetab === 6" #deleteTab></app-delete-user>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
